import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useOfferClock } from '../hooks/useOfferClock';
export function ScarcityBar() {
  const {
    spotsLeft,
    totalSpots,
    filledPercent
  } = useOfferClock();
  return <div className="w-full" data-id="element-93" data-mp="2l3v3iqoiqe7y">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-94" data-mp="2l4o1b25i1tdy">
        <span className="flex items-center gap-1.5 text-pulse" data-id="element-95" data-mp="2q2ptqdotf523">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="2b68m9xjqyakt" />
          Only {spotsLeft} spots left at $27
        </span>
        <span className="tabular-nums text-muted" data-id="element-97" data-mp="2g6w884t4c186">{Math.round(filledPercent)}% claimed</span>
      </div>
      <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-pulse-100 ring-1 ring-inset ring-pulse/20" role="progressbar" aria-valuemin={0} aria-valuemax={totalSpots} aria-valuenow={totalSpots - spotsLeft} aria-label="Promotional spots claimed" data-id="element-98" data-mp="227dewi4yuufx">
        <div className="relative h-full rounded-full bg-pulse transition-[width] duration-300 ease-out" style={{
        width: `${filledPercent}%`
      }} data-id="element-99" data-mp="5d9xh36tuo52">
          <span className="absolute inset-y-0 right-1.5 my-auto h-2 w-2 rounded-full bg-white animate-live" data-id="element-100" data-mp="2zm2uziuf8s5r" />
        </div>
      </div>
      <p className="mt-2 text-xs text-muted" data-id="element-101" data-mp="3dbwm67tefoin">
        When the remaining {spotsLeft} promotional spots are claimed, the price returns to normal.
      </p>
    </div>;
}